// extracted by mini-css-extract-plugin
export default {"link":"VK-z","disabled":"WK-z"};